import StudentFields from './StudentFields';

/**
 * Container principal d'une évaluation ou d'un entraînement : sheet A4
 * + bandeau élève (si évaluation) + body + footer.
 *
 * Le masthead (CompactHeader) est rendu en tête de CHAQUE .ep-page par
 * EvalPrintPage — il n'est plus global à la sheet.
 *
 * Props :
 *   - meta: { titre, classe, duree, bareme, date, documentType }
 *   - compact: mode de densité « Compact » (classe .ep-compact — doit être
 *     posée à l'identique sur la feuille de MESURE, cf. EvalPrintPage)
 *   - innerRef / style : ajustement responsive de l'aperçu (réduction
 *     visuelle par transform quand l'écran est plus étroit que l'A4 —
 *     cf. useSheetFit dans EvalPrintPage). Jamais posés sur la feuille de
 *     mesure.
 *   - children: ReactNode (les .ep-page déjà paginées)
 */
// `sansBandeau` : feuille sans les champs élève (corrigé seul, /print-groupes).
const EvalSheet = ({ meta = {}, compact = false, sansBandeau = false, innerRef = null, style = undefined, children }) => {
    const isEntrainement = meta.documentType === 'entrainement';
    const footerLabel = meta.titre || (isEntrainement ? 'Exercice d\'entraînement' : 'Évaluation');
    return (
        <div className={`ep-sheet${compact ? ' ep-compact' : ''}`} ref={innerRef} style={style}>
            {!isEntrainement && !sansBandeau && <StudentFields />}
            <main className="ep-body">{children}</main>
            <footer className="ep-footer">
                <span>{footerLabel}</span>
                <span>Généré avec TanoEd</span>
            </footer>
        </div>
    );
};

export default EvalSheet;
